<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="searchListWrap">
          <!--<div>
            <h5 class="period" v-if="dataFlag">{{dateStart}}<b>-</b>{{dateEnd}}</h5>
            <h5 class="period" v-else>날짜 선택하기</h5>
            <div class="inBtn pre">
              <router-link to="./researchDate">
                <button type="button" class="searcg function">조회</button>
              </router-link>
            </div>
          </div>-->
          <div class="searchList" v-if="firstDataSet">
            <div class="center_text">
              <h5 class="period">조회기간</h5>
              <div class="inBtnWrap">
                <h5 class="period date" v-if="dataFlag">
                  {{ dateStart }}<b>-</b>{{ dateEnd }}
                </h5>
                <h5 class="period date" v-else>전체조회기간입니다.</h5>
                <div class="inBtn pre red">
                  <router-link to="./researchDate">
                    <button type="button" class="search function">
                      조회하기
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="card_wrap">
              <div
                class="card_list"
                v-for="(reservationItem, i) in reservationSet"
                :key="i"
              >
                <div class="cl_title">
                  <h2 class="white">{{ reservationItem.doctorName }}</h2>
                  <div
                    class="cl_btn"
                    v-if="reservationItem.state === '예약완료'"
                  >
                    <router-link to="./updateDate">
                      <button
                        type="button"
                        class="red"
                        @click="updateReservation(i)"
                      >
                        변경
                      </button>
                    </router-link>
                    <button
                      type="button"
                      class="black"
                      @click="deleteActionCall(i)"
                    >
                      취소
                    </button>
                  </div>
                </div>
                <div class="cl_content black">
                  <div class="content_item">
                    <div class="ci_title">
                      <label>예약일시</label>
                    </div>
                    <div class="ci_content">
                      <p>
                        {{
                          reservationItem.reservationDate | moment("YYYY.MM.DD")
                        }}
                        {{ reservationItem.reservationDate | moment("HH:mm") }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--<div class="searchHeader">
              <div class="item"><p>의료진</p></div>
              <div class="item exception"><p>예약일시</p></div>
            </div>
            <div class="searchContent">
              <div class="list" v-for="(reservationItem, i) in reservationSet" :key="i">
                <div class="item">
                  <p>{{reservationItem.doctorName}}</p>
                </div>
                <div class="item issue">
                  <p>{{reservationItem.reservationDate | formatTimeList}}</p>
                </div>
                <div class="item">
                  <div class="buttonInduction reservationBtn" v-if="reservationItem.state === '예약완료'">
                  <div class="inBtn">
                    <router-link to="./updateDate">
                      <button type="button" class="red" @click="updateReservation(i)">변경</button>
                    </router-link>
                  </div>
                  <div class="inBtn">
                      <button type="button" @click="deleteActionCall(i)">취소</button>
                  </div>
                  </div>
                </div>
              </div>
            </div>-->
          </div>
          <div v-else>
            <div class="center_text surgery emptyList">
              <div class="parts">
                <h5 class="period">조회기간</h5>
                <div class="inBtnWrap">
                  <h5 class="period date" v-if="dataFlag">
                    {{ dateStart }}<b>-</b>{{ dateEnd }}
                  </h5>
                  <h5 class="period date" v-else>전체조회기간입니다.</h5>
                  <div class="inBtn pre red">
                    <router-link to="./researchDate">
                      <button type="button" class="search function">
                        조회하기
                      </button>
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="imgWrap">
                <img src="@/assets/images/error.svg" />
              </div>
              <div class="ct_content">
                <p>예약 내역이 없습니다.</p>
              </div>
              <div class="small_btnWrap one">
                <router-link to="/reservation/explain">
                  <button type="button">예약하러가기</button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <add-popup
      v-if="checkPopup"
      :popupSet="popupSet"
      @causeAction="deleteAction()"
    />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import EventBus from '@/utils/bus'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        closeType: 'close'
      },
      transDate: {
        headerName: '예약조회',
        prevUrl: '/'
      },
      dataFlag: false,
      today: '',
      currentDaysSet: [],
      currentDayLast: '',
      lastDayment: '',
      dateStart: '',
      dateEnd: '',
      IsWhole: '',
      firstDataSet: false,
      deleteParam: '',
      orderParam: '',
      reservationSet: [],
      setCount: false,
      currentTimeValue: ''
    }
  },
  computed: {
    ...mapGetters(['GET_RESERVATION_LIST', 'GET_RESERVATION_SEARCH']),
    ...mapState(['checkPopup'])
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    if (this.GET_RESERVATION_SEARCH.length >= 1) {
      this.dataFlag = true
      this.dateStart = this.GET_RESERVATION_SEARCH[0]
      this.dateEnd = this.GET_RESERVATION_SEARCH[1]
      this.IsWhole = this.GET_RESERVATION_SEARCH[2]
      console.log('this.isWhole: ', this.IsWhole)
    } else {
      this.dataFlag = false
    }
    this.getDefaultDate()
    this.fetchData()
  },
  mounted () {
    EventBus.$emit('pageAccess', true)
  },
  filters: {
    formatTimeList: function (value) {
      value = value.toString()
      const date = value.substr(0, 10)
      const time = value.substr(11, 14)
      const target = date + '\n' + time
      return target
    }
  },
  methods: {
    ...mapMutations([
      'SET_POPUP',
      'SET_RESERVATION_ITEM_INFO',
      'SET_RESERVATION_SEARCH'
    ]),
    ...mapActions(['FETCH_RESERVATION_LIST', 'DELETE_RESERVATION']),
    callPrev () {
      if (this.setCount) {
        if (
          sessionStorage.getItem('pathFromLoadUnAuth') === '/reservation/reCare'
        ) {
          this.$router.push('/reservation/reCare')
        } else {
          this.$router.push('/')
        }
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    },
    // 오늘과 마지막일짜를 구하는 함수
    getDefaultDate () {
      const existDate = []
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const hour = date.getHours()
      const minute = date.getMinutes()
      const timeNow = hour * 60 + minute
      console.log('이게 시간입니다.', timeNow)
      this.currentTimeValue = timeNow
      const dateMutated = new Date(year, month, 0)
      console.log('datedMutated', dateMutated)
      const lastDay = dateMutated.getDate()
      let monthValue
      let dayValue
      let transDate
      let today
      if (String(month).length < 2) {
        monthValue = '-0' + String(month)
      } else {
        monthValue = '-' + String(month)
      }
      if (String(day).length < 2) {
        dayValue = '-0' + String(day)
      } else {
        dayValue = '-' + String(day)
      }
      console.log('재료', String(year) + String(monthValue) + String(dayValue))
      const material = String(year) + monthValue + '-'
      const material2 = String(year) + monthValue + '-0'
      const repeatLength = day
      for (let i = 1; i < repeatLength + 1; i++) {
        if (i < 10) {
          transDate = material2 + i
        } else {
          transDate = material + i
        }
        existDate.push(transDate)
      }
      if (String(day).length < 2) {
        today = String(material2 + day)
      } else {
        today = String(material + day)
      }
      const lastDayment = String(material + lastDay)
      this.today = today
      this.currentDaysSet = existDate
      this.currentDayLast = lastDay
      this.lastDayment = lastDayment
    },
    // 예약조회를 실행함
    async fetchData () {
      try {
        let requestData
        if (this.dataFlag === false) {
          requestData = {
            lte: null,
            gte: null,
            default: true
          }
        } else {
          requestData = {
            lte: this.dateEnd,
            gte: this.dateStart,
            default: this.IsWhole
          }
        }
        await this.FETCH_RESERVATION_LIST(requestData).then(() =>
          this.carryData()
        )
      } catch (error) {
        console.log('error :', error);
        console.log('예약조회 api에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    initData () {
      this.reservationSet = []
      this.carryData()
    },
    calculateTime () {
      return true
    },
    carryData () {
      const loopLength = this.GET_RESERVATION_LIST.length
      const checkDataSetMoto = []
      for (let i = 0; i < loopLength; i++) {
        if (
          this.GET_RESERVATION_LIST[i].state !== '취소' &&
          this.GET_RESERVATION_LIST[i].state !== '미방문'
        ) {
          if (
            new Date(this.GET_RESERVATION_LIST[i].reservationDate) <=
              new Date() &&
            this.GET_RESERVATION_LIST[i].state === '예약완료'
          ) {
          } else {
            checkDataSetMoto.push(this.GET_RESERVATION_LIST[i])
          }
        }
      }
      if (this.GET_RESERVATION_LIST.length >= 1) {
        if (checkDataSetMoto.length !== 0) {
          this.firstDataSet = true
        }
      } else {
        this.firstDataSet = false
      }
      this.reservationSet = checkDataSetMoto
    },
    deleteActionCall (order) {
      this.deleteParam = this.GET_RESERVATION_LIST[order].bookingCode
      this.orderParam = order
      this.SET_POPUP(true)
      this.popupSet.content = '예약을 취소하시겠습니까?'
      this.popupSet.count = 'causeActionCancelBtn'
      this.popupSet.cancelBtnText = '아니오'
      this.popupSet.confirmBtnText = '예'
    },
    viewTrans () {
      this.removeA(this.reservationSet, this.reservationSet[this.orderParam])
    },
    async deleteAction () {
      try {
        const requestData = {
          bookingCode: this.deleteParam
        }
        await this.DELETE_RESERVATION(requestData).then(() => {
          this.viewTrans()
          this.SET_POPUP(false)
          this.SET_POPUP(true)
          this.popupSet.content = '예약이 취소되었습니다.'
          this.popupSet.count = 'single'
          this.popupSet.confirmBtnText = '확인'
        })
      } catch (error) {
        console.log('error :', error);
        console.log('예약취소 api에서 에러발생.')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    removeA (arr) {
      let what
      const a = arguments
      let L = a.length
      let ax
      while (L > 1 && arr.length) {
        what = a[--L]
        while ((ax = arr.indexOf(what)) !== -1) {
          arr.splice(ax, 1)
        }
      }
      return arr
    },
    updateReservation (order) {
      const bookingCode = this.GET_RESERVATION_LIST[order].bookingCode
      const parent = document.querySelector('.card_list').parentNode.childNodes[
        order
      ]
      const trimValue = parent.childNodes[1].childNodes[0].childNodes[1].textContent.trim()
      const currentYear = trimValue.substr(
        0,
        4
      )
      const currentMonth = trimValue.substr(
        5,
        2
      )
      const currentDay = trimValue.substr(
        8,
        2
      )
      const currentHour = trimValue.substr(
        11,
        2
      )
      const currentMinute = trimValue.substr(
        14,
        2
      )
      console.log('bookingCode: ', bookingCode)
      console.log('parent: ', parent)
      console.log('currentYear: ', currentYear)
      console.log('currentMonth: ', currentMonth)
      console.log('currentDay: ', currentDay)
      console.log('currentHour: ', currentHour)
      console.log('currentMinute: ', currentMinute)
      const currentTime = currentHour + currentMinute
      const daySet = currentYear + '-' + currentMonth + '-' + currentDay
      const doctorCode = this.GET_RESERVATION_LIST[order].doctorCode
      const doctorName = this.GET_RESERVATION_LIST[order].doctorName
      const doctorPhotoUrl = this.GET_RESERVATION_LIST[order].doctorPhotoUrl
      const transRequest = {
        parents: parent,
        currentYear: currentYear,
        currentMonth: currentMonth,
        currentDay: currentDay,
        daySet: daySet,
        bookingCode: bookingCode,
        currentTime: currentTime,
        doctorCode: doctorCode,
        doctorName: doctorName,
        doctorPhotoUrl: doctorPhotoUrl
      }
      this.$store.commit('SET_RESERVATION_ITEM_INFO', transRequest)
    }
  },
  beforeDestroy () {
    if (this.GET_RESERVATION_SEARCH.length >= 1) {
      this.SET_RESERVATION_SEARCH('')
      this.dataFlag = false
    }
    this.SET_POPUP(false)
    this.setCount = false
    EventBus.$off('pageAccess')
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  }
}
</script>

<style lang="scss" scoped>
</style>
